import { atom, selector } from "recoil"
import {
  ShoppableVideo,
  ShoppableVideoSetterAction,
  ShoppableMNPVideoProps,
  ShoppableMNPVideoCallbackSelectorProps,
  ShoppableVideosListCallbackSelectorProps,
  ShoppableVideosAfterPictureNoPresentProps,
  ShoppableVideosAfterPictureNoPresentCallbackSelectorProps
} from "./types"

export const shoppableVideosListAtom = atom<ShoppableVideo[]>({
  key: "shoppableVideosListAtom",
  default: []
})

export const shoppableMNPVideoAtom = atom<ShoppableMNPVideoProps>({
  key: "shoppableMNPVideoAtom",
  default: {
    idShoppableMNP: "",
    enabledShoppableMNP: false,
    srcShoppableMNP: "",
    typeShoppableMNP: "play"
  }
})

export const shoppableVideosFilterState = atom<{
  textField: string
  optionSort: string
}>({
  key: "shoppableVideosFilterState",
  default: {
    textField: "",
    optionSort: ""
  }
})

export const shoppableVideosAfterPictureNoPresentAtom =
  atom<ShoppableVideosAfterPictureNoPresentProps>({
    key: "shoppableVideosAfterPictureNoPresentAtom",
    default: {
      isShoppableVideosAfterPictureNoPresent: false,
      shoppableVideosAfterPictureNoPresentHostId: ""
    }
  })

export const shoppableVideosListSelector = selector({
  key: "shoppableVideosListSelector",
  get: ({ get }) => {
    const value = get(shoppableVideosFilterState)
    const shoppableVideosList = get(shoppableVideosListAtom)

    const sort = (a, b) => {
      if (value.optionSort === "lowestPrice") {
        return +a.currentPrice.substr(1) - +b.currentPrice.substr(1)
      }
      if (value.optionSort === "highestPrice") {
        return +b.currentPrice.substr(1) - +a.currentPrice.substr(1)
      }

      if (value.optionSort === "alphabetically") {
        const titleA = a.title.toLowerCase(),
          titleB = b.title.toLowerCase()
        if (titleA < titleB) {
          return -1
        }
        if (titleA > titleB) {
          return 1
        }
      }
      return 0
    }

    const sortArray = [...shoppableVideosList].sort(sort)

    if (value?.textField?.length > 0) {
      return sortArray.filter(badge => {
        return badge.title.toLowerCase().match(value.textField.toLowerCase())
      })
    } else {
      return sortArray
    }
  },
  set: ({ set, reset, get }, action: any) => {
    const { name, shoppableVideoData, shoppableVideoId } =
      action as ShoppableVideoSetterAction

    if (name ==="ADD" || name === "UPDATE") {
      set(shoppableVideosListAtom, prev => {
         // eslint-disable-next-line eqeqeq
        const isIdPresent = prev.some(item => item.id == shoppableVideoData.id)

        if(isIdPresent) {
          // As item is already present, update the old item
          const result = prev.map(item => {
            // eslint-disable-next-line eqeqeq
            if (item.id == shoppableVideoData.id) {
              return { ...item, ...shoppableVideoData }
            }
            return item
          })

          return result
        }

        // Add the new item
        return [...prev, shoppableVideoData];
      })
    }

    if (name === "DELETE") {
      set(shoppableVideosListAtom, prev => {
        // eslint-disable-next-line eqeqeq
        const result = prev.filter(item => item.id != shoppableVideoId)

        return result
      })
    }

    if (name === "RESET") {
      set(shoppableVideosListAtom, prev => {
        return []
      })
    }
  }
})

export const shoppableMNPVideoCallbackSelector =
  selector<ShoppableMNPVideoCallbackSelectorProps>({
    key: "shoppableMNPVideoCallbackSelector",
    get: ({ getCallback }) => {
      const handleReturnData = getCallback(({ snapshot }) => async () => {
        const data = await snapshot.getPromise(shoppableMNPVideoAtom)

        return data
      })
      return { handleReturnData }
    }
  })

export const shoppableVideosListCallbackSelector =
  selector<ShoppableVideosListCallbackSelectorProps>({
    key: "shoppableVideosListCallbackSelector",
    get: ({ getCallback }) => {
      const handleReturnData = getCallback(({ snapshot }) => async () => {
        const data = await snapshot.getPromise(shoppableVideosListAtom)

        return data
      })
      return { handleReturnData }
    }
  })

export const shoppableVideosAfterPictureNoPresentCallbackSelector =
  selector<ShoppableVideosAfterPictureNoPresentCallbackSelectorProps>({
    key: "shoppableVideosAfterPictureNoPresentCallbackSelector",
    get: ({ getCallback }) => {
      const handleReturnData = getCallback(({ snapshot }) => async () => {
        const data = await snapshot.getPromise(
          shoppableVideosAfterPictureNoPresentAtom
        )

        return data
      })
      return { handleReturnData }
    }
  })
